export default "__VITE_ASSET__D$FIy1FL__"